/* //show a menue with categories //sow a sub menue with items //allow selection
//save to a collection //each item is a document in the database //should //
//start with a category page //select a category of houshold items ///grab item
list ///start with the first item ////show the item name ////show the seach
parameters //// seach for the price //// get a price and a screenshot /// if
error ask to change the parameters //try again /add your own //save to list as a
document */

<template>
  <div>
    <v-row class="">
      <v-flex xs8 sm5 md4 lg4 class="ma-auto pt-4" v-if="!category">
        <v-card
          style="margin: auto; overflow: scroll;"
          max-width="600px"
          max-height="80vh"
          v-if="!category"
        >
          <v-card-title class="text-h6 text-md-h5 text-lg-h5 text-no-wrap"
            >Please Select a Category</v-card-title
          >
          <!-- <v-card-text>Please Select a Category</v-card-text> -->
          <v-progress-circular
            color="green"
            v-if="menu.length < 3"
            indeterminate
          ></v-progress-circular>
          <v-combobox
            class="ma-2"
            :items="menu"
            v-model="category"
          ></v-combobox>
          <div>
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="(menuItem, i) in menu" :key="i">
                  <v-list-item-content @click="select = menuItem">
                    <v-list-item-title> {{ menuItem }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon>
                    <!-- <v-icon v-text="icon.done" color="success"></v-icon> -->
                    <v-icon
                      v-text="icon.started"
                      v-if="startedCategoryList.includes(menuItem)"
                    ></v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>
        </v-card>
      </v-flex>
      <!-- <v-btn v-if="category" @click="clearCat">BACK</v-btn> -->

      <v-flex xs8 sm5 md4 lg4 class="ma-auto pt-4" v-if="category">
        <v-card
          class="ma-auto"
          max-width="600px"
          height="80vh"
          style="margin: auto; overflow: scroll;"
        >
          <v-toolbar color="cyan" dark>
            <v-toolbar-title>{{ category }}</v-toolbar-title>

            <v-spacer></v-spacer>
          </v-toolbar>
          <!-- <v-card-title>{{ category }}</v-card-title> -->
          <v-card-actions>
            <v-btn
              style="position: sticky;"
              color="success"
              v-if="category"
              @click="clearCat"
              >CHANGE CATEGORY</v-btn
            >
            <v-btn small rounded @click="addItemDialog = true" color="primary"
              >ADD YOUR OWN ITEM</v-btn
            >
          </v-card-actions>
          <v-card-title>Please Select a Household Item</v-card-title>

          <v-combobox
            class="ma-2"
            :items="items"
            item-text="title"
            v-model="selectedItem"
          ></v-combobox>
          <v-card
            flat
            style="overflow: scroll;"
            max-width="550px"
            height="50vh"
          >
            <v-list>
              <v-list-item-group color="primary" v-model="selectedItemIndex">
                <v-list-item v-for="(item, i) in items" :key="i">
                  <!-- <v-list-item-content @click="selectedItem = item"> -->
                  <v-list-item-content @click="selectItem(i)">
                    <v-list-item-title> {{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon>
                    <v-icon
                      v-if="item.withinContentsList"
                      v-text="icon.done"
                    ></v-icon>
                    <!-- <v-icon v-text="icon.started"></v-icon> -->
                  </v-list-item-icon>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-card>
      </v-flex>
      <v-flex xs8 sm6 md4 lg4 class="ma-auto pt-4">
        <v-card
          max-width="600"
          max-height="80vh"
          min-height="80vh"
          class="ma-auto"
          style="margin: auto;"
        >
          <v-toolbar color="green lighten-2">
            <v-btn small fab @click="previousItem"
              ><v-icon
                :disabled="selectedItemIndex === 0"
                v-text="icon.back"
              ></v-icon
            ></v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>SELECTED ITEM</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small fab @click="nextItem"
              ><v-icon v-text="icon.next"></v-icon
            ></v-btn>
          </v-toolbar>
          <v-progress-linear
            color="deep-purple accent-4"
            indeterminate
            rounded
            height="6"
            v-if="overlay"
          ></v-progress-linear>
          <!-- <v-card-title>SELECTED ITEM</v-card-title> -->
          <v-expand-transition>
            <!-- <v-form ref="form" v-model="valid" lazy-validation> -->
            <v-card v-if="selectedItem !== null">
              <v-card-title>{{ selectedItem.title }}</v-card-title>
              <v-form
                ref="form"
                v-if="itemObject !== null && itemObject !== undefined"
              >
                <v-text-field
                  v-model="quantity"
                  label="Quantity"
                  type="number"
                  required
                  class="ma-auto pa-2"
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="selectedItem.userDescription"
                  label="Brief Description"
                  class="ma-auto pa-2"
                  dense
                ></v-text-field>
                <v-select
                  :items="householdLabels"
                  v-model="storeSelection"
                  label="Store Selector (optional)"
                  class="ma-auto pa-2"
                  dense
                ></v-select>
                <v-card-actions>
                  <!-- <v-btn fab @click="selectedItem.quantity += 1" color="green" -->
                  <v-btn fab @click="addQuantity" color="green">+</v-btn>
                  <v-btn
                    :disabled="quantity === 0"
                    color="success"
                    class="ma-auto pa-2"
                    @click="addItem"
                    dense
                  >
                    ADD TO LIST
                  </v-btn>
                  <v-btn
                    fab
                    color="orange"
                    :disabled="quantity === 0"
                    @click="subQuantity"
                    >-</v-btn
                  >
                  <!-- <v-btn
                    fab
                    color="orange"
                    :disabled="selectedItem.quantity === 0"
                    @click="selectedItem.quantity - 1"
                    >-</v-btn
                  > -->
                </v-card-actions>
              </v-form>
              <v-row>
                <v-card-text v-if="withinContentsList === true"
                  >THIS ITEM HAS BEEN ADDED
                  <v-icon v-text="icon.done" color="success"></v-icon
                ></v-card-text>
                <v-card-text
                  v-if="withinContentsList === true"
                  @click="removeItem()"
                  >Remove Item <v-icon v-text="icon.delete" color="red"></v-icon
                ></v-card-text>
              </v-row>
              <v-card-text v-if="withinContentsList === false"
                >NOT IN CONTENTS LIST</v-card-text
              >
            </v-card>
          </v-expand-transition>
          <v-expand-transition
            max-height="50%"
            v-if="
              role == 'admin' && this.selectedItem && !this.selectedItem.pricing
            "
          >
            <v-card height="30vh" style="overflow: scroll;" flat>
              <div v-if="this.selectedItem && this.selectedItem.pricing">
                <v-card-title>pricing: </v-card-title>
                <v-card-text
                  >final price:
                  {{
                    this.selectedItem.pricing.finalPrice
                      ? this.selectedItem.pricing.finalPrice
                      : ""
                  }}</v-card-text
                >
                <a
                  v-if="this.selectedItem.pricing.finalLink"
                  :href="this.selectedItem.pricing.finalLink"
                  target="_blank"
                  >FINAL LINK:</a
                >

                <v-card-text v-if="this.selectedItem.pricing.finalLink"
                  >final link:
                  {{ this.selectedItem.pricing.finalLink }}</v-card-text
                >
                <a :href="this.selectedItem.pricing.pdfPath" target="_blank"
                  >FINAL PDF:</a
                >
                <v-card-text v-if="this.selectedItem.pricing.pdfPath"
                  >final PDF:
                  {{
                    this.selectedItem.pricing.pdfPath
                      ? this.selectedItem.pricing.pdfPath
                      : "NONE"
                  }}</v-card-text
                >
                <iframe
                  v-if="this.selectedItem.pricing.pdfPath"
                  :src="this.selectedItem.pricing.pdfPath"
                  frameborder="0"
                ></iframe>
              </div>
              <div v-if="this.selectedItem && !this.selectedItem.pricing">
                NEED TO GET PRICING
              </div>
            </v-card>
          </v-expand-transition>
          <v-expand-transition
            max-height="50%"
            v-if="
              role == 'admin' && this.selectedItem && this.selectedItem.pricing
            "
          >
            <v-card height="30vh" style="overflow: scroll;" flat>
              <v-card-title>pricing: </v-card-title>
              <v-card-text
                >final price:
                {{
                  this.selectedItem.pricing.finalPrice
                    ? this.selectedItem.pricing.finalPrice
                    : ""
                }}</v-card-text
              >
              <a
                v-if="this.selectedItem.pricing.finalLink"
                :href="this.selectedItem.pricing.finalLink"
                target="_blank"
                >FINAL LINK:</a
              >

              <v-card-text v-if="this.selectedItem.pricing.finalLink"
                >final link:
                {{ this.selectedItem.pricing.finalLink }}</v-card-text
              >
              <a :href="this.selectedItem.pricing.pdfPath" target="_blank"
                >FINAL PDF:</a
              >
              <v-card-text v-if="this.selectedItem.pricing.pdfPath"
                >final PDF:
                {{
                  this.selectedItem.pricing.pdfPath
                    ? this.selectedItem.pricing.pdfPath
                    : "NONE"
                }}</v-card-text
              >
              <v-btn color="green" @click="viewPDF">VIEW</v-btn>
            </v-card>
          </v-expand-transition>
        </v-card>
      </v-flex>
      <v-flex xs8 sm6 md3 lg2 class="ma-auto pt-4">
        <v-card style="margin: auto;" max-height="80vh" min-height="80vh">
          <v-toolbar color="secondary" dark>
            <v-toolbar-title
              >UNPRICED CONTENTS LIST:
              {{ sortedList ? sortedList.length : "" }}</v-toolbar-title
            >

            <v-spacer></v-spacer>
            <v-file-input
              v-if="role === 'admin'"
              class="ma-2 mt-6"
              autofocus
              outlined
              chips
              multiple
              label="UPLOAD EXISTING LIST"
              ref="fileInput"
              @change="onFilePicked"
              accept=".xls, .xlsx"
              dense
              color="#2E5473"
            ></v-file-input>
          </v-toolbar>
          <v-combobox
            class="ma-2"
            :items="sortedList"
            v-model="selectedItemFormContentsList"
            item-text="title"
            label="GO TO ITEM"
            clearable
            return-object
          ></v-combobox>
          <!-- <v-card-title>CONTENTS LIST</v-card-title> -->
          <v-card style="overflow: scroll;" height="60vh" flat>
            <v-list subheader two-line flat>
              <v-btn small v-if="role === 'admin'" @click="priceAll"
                >price all</v-btn
              >

              <div v-for="(contentsItem, i) in sortedList" :key="i">
                <v-list-item class="pa-0">
                  <!-- <v-btn @click="selectItemFromContentsList(contentsItem)"
                    >view</v-btn
                  > -->
                  <v-list-item-content
                    @click="selectItemFromContentsList(contentsItem)"
                  >
                    <v-list-item-title :id="i"
                      >{{ i + 1 }}: {{ contentsItem.title }}</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      contentsItem.category
                    }}</v-list-item-subtitle>
                    <v-list-item-subtitle
                      >QTY:{{ contentsItem.quantity }}</v-list-item-subtitle
                    >
                    <v-list-item-subtitle
                      v-if="
                        contentsItem.pricing !== null &&
                          contentsItem.pricing !== undefined
                      "
                    >
                      price:
                      {{
                        contentsItem.pricing.finalPrice &&
                        contentsItem.pricing.finalPrice
                          ? contentsItem.pricing.finalPrice
                          : ""
                      }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-icon
                    v-if="
                      contentsItem.pricing && contentsItem.pricing.finalPrice
                    "
                    v-text="icon.done"
                    color="success"
                  ></v-icon>
                  <v-icon
                    v-if="!contentsItem.pricing"
                    v-text="icon.error"
                    color="red"
                  ></v-icon>
                  <v-icon
                    v-if="!contentsItem.pricing && role === 'admin'"
                    v-text="icon.run"
                    color="green"
                    @click="priceItem(contentsItem)"
                  ></v-icon>
                  <v-btn small color="yellow" @click="flagItem(contentsItem)"
                    >flag</v-btn
                  >

                  <!-- </template> -->
                </v-list-item>
              </div>
            </v-list>
          </v-card>
        </v-card>
      </v-flex>

      <v-flex
        xs8
        sm6
        md2
        lg2
        class="ma-1 pt-4"
        v-if="toReviewList.length > 0 || savedReviewList.length > 0"
      >
        <v-expand-x-transition>
          <v-card
            style="margin: auto; overflow:auto;"
            max-width="600px"
            height="80vh"
          >
            <v-toolbar v-if="toReviewList.length > 0" color="red lighten-2">
              <v-toolbar-title>ITEMS TO BE REVIEWED</v-toolbar-title>

              <v-spacer></v-spacer>
            </v-toolbar>

            <v-list subheader two-line flat>
              <v-list-item-group>
                <div v-for="(toReviewItem, i) in toReviewList" :key="i">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        toReviewItem.title
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        toReviewItem.category
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-list-item-group>
              <v-card-actions v-if="toReviewList.length > 0"
                ><v-btn color="primary" @click="saveReviewItems"
                  >SAVE</v-btn
                ></v-card-actions
              >
              <v-toolbar
                color="red darken-3"
                dark
                v-if="savedReviewList && savedReviewList.length > 0"
              >
                <v-toolbar-title>ITEMS UNDER REVIEW</v-toolbar-title>
              </v-toolbar>

              <v-card flat style="overflow: scroll;" height="75vh">
                <v-list-item-group>
                  <div v-for="(reviewItem, i) in savedReviewList" :key="i">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          reviewItem.title
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          reviewItem.category
                        }}</v-list-item-subtitle>

                        <v-list-item-action
                          ><v-btn small @click="removeReviewItem(reviewItem)"
                            ><v-icon v-text="icon.delete"></v-icon></v-btn
                        ></v-list-item-action>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-list-item-group>
              </v-card>
            </v-list>
          </v-card>
        </v-expand-x-transition>
      </v-flex>
      <v-flex xs8 sm6 md2 lg2 class="ma-auto pt-4" v-if="pricedList.length > 0">
        <v-expand-x-transition>
          <v-card
            style="margin: auto; overflow:auto;"
            max-width="600px"
            height="80vh"
          >
            <v-toolbar v-if="pricedList.length > 0" color="red lighten-2">
              <v-toolbar-title
                >PRICED ITEMS: {{ pricedList.length }}
              </v-toolbar-title>

              <v-spacer></v-spacer>
              <v-btn small color="green lighten-2" @click="report()"
                >REPORT</v-btn
              >
            </v-toolbar>
            <v-combobox
              class="ma-2"
              :items="sortedPricedList"
              v-model="selectedItemFromPricedList"
              item-text="title"
              label="GO TO ITEM"
              clearable
              return-object
            ></v-combobox>
            <v-list subheader two-line flat>
              <v-list-item-group>
                <div v-for="(pricedItem, i) in sortedPricedList" :key="i">
                  <v-list-item>
                    <v-list-item-content
                      @click="selectItemFromPricedList(pricedItem)"
                    >
                      <v-list-item-title
                        >{{ pricedItem.title }} :
                        {{
                          pricedItem.pricing.finalPrice.toLocaleString(
                            "en-US",
                            {
                              style: "currency",
                              currency: "USD"
                            }
                          )
                        }}</v-list-item-title
                      >
                      <v-list-item-subtitle>{{
                        pricedItem.category
                      }}</v-list-item-subtitle>
                      <v-list-item-subtitle
                        >QTY: {{ pricedItem.quantity }}</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-list-item-group>
              <!-- <v-card-actions v-if="toReviewList.length > 0"
                ><v-btn color="primary" @click="saveReviewItems"
                  >SAVE</v-btn
                ></v-card-actions
              > -->
            </v-list>
          </v-card>
        </v-expand-x-transition>
      </v-flex>
    </v-row>
    <v-dialog v-model="selectDialog" max-width="500px">
      <v-card
        ><v-card-title>{{ select }}</v-card-title>
        <v-card-actions
          ><v-btn color="red" @click="deSelect">BACK</v-btn><v-spacer></v-spacer
          ><v-btn color="green" @click="goToCat">GO</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addItemDialog" max-width="600px">
      <v-card
        class="mx-auto"
        max-width="600px"
        outlined
        rounded
        text
        style="border: 1px #1e88e5 solid"
      >
        <v-card-text>
          <v-text-field
            label="Name of Item"
            v-model="newItemName"
          ></v-text-field>
          <v-combobox
            label="Category"
            :items="menu"
            v-model="category"
          ></v-combobox>
          <v-text-field
            label="Quantity"
            v-model="newItemQuantity"
            number
            type="number"
          ></v-text-field>
          <v-text-field
            label="Description"
            v-model="newItemDescription"
          ></v-text-field>
          <!-- <v-expand-transition>
            <v-text-field
              label="Final Price"
              v-model="tempFinalPrice"
              type="number"
              prefix="$"
              outlined
              rounded
              dense
              color="primary"
              class="ma-3"
              v-if="selfPricingNewItem"
            ></v-text-field>
          </v-expand-transition>
          <v-expand-transition>
            <v-text-field
              label="Final Link"
              v-model="tempFinalLink"
              outlined
              rounded
              dense
              color="primary"
              class="ma-3"
              v-if="selfPricingNewItem"
            ></v-text-field>
          </v-expand-transition>
          <v-expand-transition>
            <v-btn
              small
              color="orange"
              depressed
              @click="selfPricingNewItem = true"
              >Self Price This Item</v-btn
            >
          </v-expand-transition> -->
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="!category" color="success" @click="addNewItem"
            >ADD NEW ITEM</v-btn
          >

          <v-spacer></v-spacer>

          <v-btn large rounded @click="cancelNewItemDialog">
            CANCEL
          </v-btn>
        </v-card-actions>

        <!--         -->
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editCustomItemDialog"
      max-width="800px"
      v-if="customItem !== null && customItem !== undefined"
    >
      <v-card
        class="mx-auto"
        max-width="600px"
        outlined
        rounded
        text
        style="border: 1px #1e88e5 solid"
      >
        <!-- //create an iframe to display the item link to photo -->
        <iframe
          v-if="customItem.pricing && customItem.pricing.pdfPath"
          :src="customItem.pricing.pdfPath"
          width="100%"
          height="400px"
        ></iframe>
        <div v-else>NO PDF</div>
      </v-card>
      <v-card
        class="mx-auto"
        max-width="600px"
        outlined
        rounded
        text
        style="border: 1px #1e88e5 solid"
      >
        <v-card-text>
          <v-text-field
            label="Name of Item"
            v-model="customItem.title"
          ></v-text-field>
          <v-combobox
            label="Category"
            :items="menu"
            v-model="customItem.category"
          ></v-combobox>
          <v-text-field
            label="Quantity"
            v-model="customItem.quantity"
            number
            type="number"
          ></v-text-field>
          <v-text-field
            label="Description"
            v-model="customItem.userDescription"
          ></v-text-field>
          <v-expand-transition v-if="role == 'admin'">
            <v-text-field
              label="Final Price"
              v-model="customItem.pricing.finalPrice"
              type="number"
              prefix="$"
              outlined
              rounded
              dense
              color="primary"
              class="ma-3"
            ></v-text-field>
          </v-expand-transition>
          <v-expand-transition>
            <v-text-field
              label="Final Link"
              v-model="customItem.pricing.finalLink"
              outlined
              rounded
              dense
              color="primary"
              class="ma-3"
            ></v-text-field>
          </v-expand-transition>
          <v-expand-transition
            v-if="customItem.pricing && customItem.pricing.pdfPath"
          >
            <a :href="customItem.pricing.pdfPath">screenshot link</a>
          </v-expand-transition>
        </v-card-text>
        <v-card-actions>
          <v-btn color="yellow" @click="editCustomItem">EDIT THIS ITEM</v-btn>
          <v-btn color="red" @click="removeCustomItem">DELETE THIS ITEM</v-btn>

          <v-spacer></v-spacer>

          <v-btn large rounded @click="cancelEditCustomItem">
            CANCEL
          </v-btn>
        </v-card-actions>

        <!--         -->
      </v-card>
    </v-dialog>
    <v-dialog v-model="overlay2" :scrim="false" persistent width="auto">
      <v-card color="primary">
        <v-card-text>
          Please stand by while we process your request. This may take a few
          minutes.
          <v-progress-linear
            v-model="progress"
            height="7"
            color="purple"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="finalDocDialog" width="auto">
      <v-card style="height: 700px">
        <v-btn small rounded color="red" @click="finalDocDialog = false"
          >close</v-btn
        >
        <v-btn color="primary" large rounded @click="downloadDocs"
          >DOWNLOAD</v-btn
        >
        <iframe
          :src="iframeSrc"
          frameborder="0"
          width="100%"
          height="100%"
        ></iframe>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from "firebase";
// import slugify from "slugify";
// import { getApp } from "firebase/app";
// import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// const functions = getFunctions(getApp());
// connectFunctionsEmulator(functions, "localhost", 5001);
// firebase.functions().useEmulator("localhost", 5001);

import * as moment from "moment";
// // import { PDFDocument, StandardFonts, rgb, PageSizes, drawPage } from "pdf-lib";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

import * as XLSX from "xlsx/xlsx.mjs";
/* load 'fs' for readFile and writeFile support */
import * as fs from "fs";
XLSX.set_fs(fs);

/* load 'stream' for stream support */
import { Readable } from "stream";
XLSX.stream.set_readable(Readable);

/* load the codepage support library for extended support with older formats  */
import * as cpexcel from "xlsx/dist/cpexcel.full.mjs";
XLSX.set_cptable(cpexcel);

export default {
  data: () => ({
    overlay: false,
    overlay2: false,
    priceOverlay: false,
    selectedItemIndex: 0,
    selfPricingNewItem: false,
    addItemDialog: false,
    editCustomItemDialog: false,
    customItem: null,
    // newItemCategory: this.category,
    newItemQuantity: 0,
    newItemDescription: null,
    newItemName: null,
    existingItemSelect: null,
    existingItemIndex: null,
    // toReviewList: [],
    menu: [],
    select: null,
    selectedItem: null,
    selectedItemFormContentsList: null,
    selectDialog: false,
    nameRules: [v => !!v || "Name is required"],
    contentsList: [],
    quantity: 0,
    userDescription: null,
    itemObject: null,
    pricing: null,
    icon: {
      started: "mdi-clock",
      done: "mdi-check",
      delete: "mdi-delete",
      back: "mdi-arrow-left",
      next: "mdi-arrow-right",
      error: "mdi-alert-circle",
      run: "mdi-currency-usd"
    },
    category: null,
    items: [],
    withinContentsList: false,
    householdLabels: [
      "Williams Sonoma",
      "Restoration Hardware",
      "West Elm",
      "HD Buttercup",
      "Joss and Main",
      "Crate and Barrel",
      "Pottery Barn",
      "Sur La Table",
      "Bed, Bath and Beyond",
      "Costco",
      "Target"
    ],
    storeSelection: null,
    matter: null,
    savedReviewList: [],
    progress: 0,
    pricedList: [],
    selectedItemFromPricedList: null,
    finalDocDialog: false,
    iframeSrc: null,
    existingList: null
  }),
  watch: {
    // selectedItemIndex(val) {
    //   console.log("selecteditem i from watch", val);
    // },
    // contentsList(val) {
    //   console.log("contentsList has changed", val);
    // },
    // pricedList(val) {
    //   console.log("pricedList has changed", val);
    // },
    // sortedPricedList(val) {
    //   console.log("sortedPricedList has changed", val);
    // },
    // sortedList(val) {
    //   console.log("sortedList has changed", val);
    // },
    selectedItemFormContentsList(val) {
      if (val !== null && val !== undefined) {
        console.log("selectedItemFromContentsList", val);
        this.category = val.category.toUpperCase();
        this.selectedItem = val;
      }
    },
    selectedItemFromPricedList(val) {
      if (val !== null && val !== undefined) {
        console.log("selectedItemFromPricedList", val);
        this.category = val.category.toUpperCase();
        this.selectedItem = val;
        this.quantity = val.quantity;
      }
    },
    // existingItemIndex(val) {
    //   console.log("existingItemIndex", val);
    //   console.log("toReviewList", this.toReviewList);
    // },
    // existingItemSelect(val) {
    //   console.log("existingItemSelect", val);
    // },
    // toReviewList(val) {
    //   console.log("toReviewList", val);
    // },
    quantity(val) {
      let num = parseInt(val);
      if (num < 0) {
        this.quantity = 0;
      }
    },

    select(val) {
      if (val !== null && val !== undefined) {
        this.selectDialog = true;
      }
    },
    selectedItem(val) {
      console.log("selectedItem", val);
      // console.log("this.selectedItemIndex", this.selectedItemIndex);
      // let selectedItemI = this.contentsList.findIndex(
      //   item => item.title === val.title
      // );
      // console.log("selectedItemI", selectedItemI);
      // let foundContentsListItem = this.contentsList[selectedItemI];
      // console.log("foundContentsListItem", foundContentsListItem);

      // console.log("user", this.user);
      // console.log("role", this.role);

      // this.category = null;
      if (val !== null && val !== undefined) {
        this.overlay = true;
        if (val.category) {
          this.category = val.category.toUpperCase();
          // }

          this.itemObject = null;
          this.quantity = 0;
          this.userDescription = null;
          this.withinContentsList = false;
          this.storeSelection = null;
          this.pricing = null;
          firebase
            .firestore()
            .collection("fireMatters")
            .doc("contents")
            .collection(this.category)
            .doc(val.title)
            .get()
            .then(resp => {
              // console.log("itemObject", resp.data());
              this.itemObject = resp.data();
              // console.log("itemObject", this.itemObject);
              if (this.itemObject !== undefined && this.itemObject !== null) {
                let q = this.contentsList.find(
                  contentsListItem =>
                    contentsListItem.title === this.itemObject.title
                );
                // console.log("q - if undefined - item not in list", q);
                let searchTerm = null;
                //if this item is in the contents list
                if (q !== null && q !== undefined) {
                  console.log("q is defined - found item in list", q);
                  //set the interface to show all the details of the item
                  this.withinContentsList = true;
                  let quant = parseInt(q.quantity);
                  this.quantity = quant;
                  this.userDescription = `${
                    q.userDescription ? q.userDescription : ""
                  }`;
                  // if (this.role == "admin") {
                  //if there is pricing for this item
                  if (q.pricing !== null && q.pricing !== undefined) {
                    this.pricing = q.pricing;
                    this.overlay = false;
                  } else {
                    // console.log("getting Pricing");
                    //make a search term TO LOOK FOR THE ITEM IN THE PRICING LIST
                    if (
                      this.userDescription !== null &&
                      this.userDescription !== ""
                    ) {
                      let term = q.title + " " + this.userDescription;
                      searchTerm = term.trim();
                    } else {
                      searchTerm = q.title.trim();
                    }

                    // console.log("searchTerms", searchTerms);
                    firebase
                      .firestore()
                      .collection("pricedItemList")
                      .doc(searchTerm)
                      .get()
                      .then(resp => {
                        if (resp.exists == true) {
                          this.pricing = resp.data();
                          // console.log("got pricing", this.pricing);
                          //go to next step
                        } else {
                          //IF THER IS NO PRICING OBJECT IN DATABASE
                          //GET PRICING
                          this.pricing = null;
                          // console.log("need to get pricing");
                        }
                        this.overlay = false;
                      })
                      .catch(e => console.error(e.message));
                  }
                } else {
                  //if q is undefined or null
                  // console.log("getting Pricing");
                  // let title = this.selectedItem.title.replace(
                  //   / *\([^)]*\) */g,
                  //   ""
                  // );
                  let q = this.pricedList.find(
                    contentsListItem => contentsListItem.title === val.title
                  );
                  if (q !== null && q !== undefined) {
                    this.withinContentsList = true;
                    let quant = parseInt(q.quantity);
                    this.quantity = quant;
                    this.userDescription = `${
                      q.userDescription ? q.userDescription : ""
                    }`;
                  }
                  let searchTerm = null;
                  if (
                    this.userDescription !== null &&
                    this.userDescription !== ""
                  ) {
                    let term = q.title + " " + this.userDescription;
                    searchTerm = term.trim();
                  } else {
                    searchTerm = this.selectedItem.title.trim();
                  }
                  firebase
                    .firestore()
                    .collection("pricedItemList")
                    .doc(searchTerm)
                    .get()
                    .then(resp => {
                      if (resp.exists == true) {
                        this.pricing = resp.data();
                        // console.log("got Pricing", this.pricing);
                        //go to next step
                      } else {
                        //IF THER IS NO PRICING OBJECT IN DATABASE
                        //GET PRICING
                        // console.log("need to get pricing");
                      }
                      this.overlay = false;
                    })
                    .catch(e => console.error(e.message));
                }
              } else {
                // console.log(
                //   "this is a unique item so lets create a new interface for it"
                // );

                firebase
                  .firestore()
                  .collection("fireMatters")
                  .doc(this.$route.params.location)
                  .collection("contentsList")
                  .doc(val.title)
                  .get()
                  .then(resp => {
                    let item = resp.data();
                    if (item !== undefined && item !== null) {
                      this.editCustomItemDialog = true;
                      // console.log("found item from db", item);
                      this.customItem = { ...item };
                      if (!item.pricing) {
                        // console.log("this item doesnt have any pricing");
                        this.customItem.pricing = {
                          finalPrice: null,
                          finalLink: null
                        };
                      }
                    } else {
                      let term = `${val.title} ${
                        val.userDescription ? val.userDescription : ""
                      }`;
                      let searchTerm = term.trim();
                      // let searchTerms = slugify(terms, {
                      //   replacement: "+",
                      //   remove: /[$*_+~.()'"!\-:@,#]/g,
                      //   lower: true
                      // });
                      firebase
                        .firestore()
                        .collection("fireMatters")
                        .doc(this.$route.params.location)
                        .collection("contentsList")
                        .doc(searchTerm)
                        .get()
                        .then(resp => {
                          let item = resp.data();
                          if (item !== undefined && item !== null) {
                            this.editCustomItemDialog = true;
                            // console.log("found item from db", item);
                            this.customItem = { ...item };
                          } else {
                            if (val.ref !== undefined && val.ref !== null) {
                              firebase
                                .firestore()
                                .collection("fireMatters")
                                .doc(this.$route.params.location)
                                .collection("contentsList")
                                .where("ref", "==", val.ref)
                                .get()
                                .then(resp => {
                                  let item = resp.data();
                                  if (item !== undefined && item !== null) {
                                    this.editCustomItemDialog = true;
                                    // console.log("found item from db", item);
                                    this.customItem = { ...item };
                                  }
                                });
                            }
                          }
                        });
                    }
                  })
                  .catch(e => console.error(e.message));
              }
            });
        }
      }
    },
    async category(val) {
      if (val !== null && val !== undefined) {
        this.overlay = true;
        // console.log("overlay is T category watcher");

        this.items = [];
        let snapshot = await firebase
          .firestore()
          .collection("fireMatters")
          .doc("contents")
          .collection(val)
          .get();

        await snapshot.forEach(item => {
          let itemData = item.data();
          // console.log(itemData.title);
          let q = this.contentsList.find(
            contentsListItem => contentsListItem.ref === itemData.ref
          );
          if (q !== null && q !== undefined) {
            this.items.push({
              title: itemData.title,
              withinContentsList: true,
              ref: itemData.ref,
              category: val.toUpperCase()
            });
          } else {
            this.items.push({
              title: itemData.title,
              withinContentsList: false,
              ref: itemData.ref,
              category: val.toUpperCase()
            });
          }
          itemData = null;
        });
        snapshot = await null;
        if (this.selectedItem !== null && this.selectedItem !== undefined) {
          let index = await this.items.findIndex(
            item => item.ref == this.selectedItem.ref
          );
          if (index !== -1) {
            // console.log("index from category watcher");
            this.selectedItemIndex = index;
          }
        }
        this.overlay = false;
        // console.log("overlay is F category watcher");
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    role() {
      return this.$store.getters.role;
    },
    toReviewList() {
      if (this.existingItemIndex && this.existingItemIndex.length > 0) {
        let arr = [];
        this.existingItemIndex.forEach(item => {
          arr.push(this.contentsList[item]);
        });

        return arr;
      } else {
        return [];
      }
    },
    sortedList() {
      // console.log("sortedList being computed ");
      let tempArray = [];
      this.contentsList.forEach(item => {
        if (!item.pricing || !item.pricing.finalPrice) {
          tempArray.push(item);
        }
      });
      // let temp = this.contentsList;
      let array = tempArray.sort(
        (firstItem, secondItem) => firstItem.category - secondItem.category
      );
      tempArray.sort((a, b) => {
        const nameA = a.category.toUpperCase(); // ignore upper and lowercase
        const nameB = b.category.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
      return array;
    },
    sortedPricedList() {
      let temp = this.pricedList;
      let array = temp.sort(
        (firstItem, secondItem) => firstItem.category - secondItem.category
      );
      temp.sort((a, b) => {
        const nameA = a.category.toUpperCase(); // ignore upper and lowercase
        const nameB = b.category.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
      return array;
    },
    startedCategoryList() {
      let arr = [];
      if (this.contentsList.length > 0) {
        this.contentsList.forEach(item => {
          arr.push(item.category.toUpperCase());
        });
      }
      return arr;
    }
  },
  methods: {
    onFilePicked() {
      if (event.target.files) {
        this.loading = true;
        this.existingList = event.target.files[0];
        this.loading = false;

        console.log("loaded");
        // let jsa = XLSX.utils.sheet_to_json(this.existingList);
        console.log("result json");
        // console.log(jsa);
        let reader = new FileReader();
        reader.readAsBinaryString(this.existingList);
        reader.onload = async () => {
          let data = reader.result;
          let workbook = XLSX.read(data, { type: "binary" });
          let first_sheet_name = workbook.SheetNames[0];
          let worksheet = workbook.Sheets[first_sheet_name];
          let json = XLSX.utils.sheet_to_json(worksheet, { raw: true });
          console.log(json);
          this.existingList = json;
          //     let functionData = {
          //   itemSlug: itemSlug,
          //   desc: item.title,
          //   titleSlug
          // };

          await this.existingList.forEach(async item => {
            if (item.DESCRIPTION && item.DESCRIPTION !== "") {
              let ref = Math.floor(Math.random() * 90000) + 10000;
              let cat = "";
              if (item.CATEGORY && item.CATEGORY !== "") {
                cat = item.CATEGORY.trim().toUpperCase();
              } else {
                cat = "MISCELLANEOUS ITEMS";
              }

              let title = item.DESCRIPTION;
              title = title.replace(/-/g, " ");
              title = title.replace(/\//g, " ").trim();
              title = title.toLowerCase();
              let quantity = null;
              if (item["QTY"] && item["QTY"] !== "") {
                quantity = item["QTY"];
              }
              let desc = "";
              let newItem = {
                title,
                ref,
                category: cat,
                userDescription: desc,
                comment: null,
                quantity
              };
              await firebase
                .firestore()
                .collection("fireMatters")
                .doc(this.$route.params.location)
                .collection("contentsList")
                .doc(newItem.title)
                .set(newItem)
                .then(() => {
                  console.log("item added");
                });
            }
          });
        };
      }
    },
    addQuantity() {
      this.quantity++;
    },
    subQuantity() {
      if (this.quantity > 0) {
        this.quantity--;
      }
    },
    async report() {
      pdfMake.fonts = {
        TimesRoman: {
          normal: "Times New Roman.ttf",
          bold: "Times New Roman Bold.ttf",
          italics: "Times New Roman Italic.ttf",
          bolditalics: "Times New Roman Bold Italic.ttf"
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf"
        },
        Zapfino: {
          normal: "Zapfino.ttf"
        }
      };
      //==================================================
      let list = [];
      this.pricedList.forEach(item => {
        item.category = item.category.toUpperCase();
        item.category = item.category.replace(/[^a-zA-Z ]/g, "");
        list.push(item);
      });
      //==================================================
      this.priceOverlay = true;
      let tableBody = [
        [
          { text: "REF", alignment: "center" },
          { text: "CATEGORY", alignment: "center" },
          { text: "QTY", alignment: "center" },
          { text: "DESCRIPTION", alignment: "center" },
          { text: "PRICE", alignment: "center" },
          { text: "ITEM TOTAL", alignment: "center" },
          { text: "SOURCE", alignment: "center" },
          { text: "SCREENSHOT", alignment: "center" },
          { text: "NOTES", alignment: "center" },
          { text: "COMMENTS", alignment: "center" }
        ]
      ];
      //==================================================
      let group = await list.reduce((r, a) => {
        r[a.category.toUpperCase()] = [
          ...(r[a.category.toUpperCase()] || []),
          a
        ];
        return r;
      }, {});
      console.log("working");
      //================================================================
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(group)) {
        value.forEach(item => {
          if (item.quantity > 0) {
            // console.log("item", item);
            if (item.pricing !== null && item.pricing !== undefined) {
              let qty = Number.parseInt(item.quantity);
              if (isNaN(qty)) {
                console.log("isNaN qty", item);
              }
              let finPrice = Number.parseFloat(item.pricing.finalPrice).toFixed(
                2
              );
              if (isNaN(finPrice)) {
                console.log("isNaN finprice", item);
              }
              let itemTot = qty * finPrice;
              let totDolar = Number.parseFloat(itemTot).toFixed(2);
              let pdfCell = {
                text: `none`
              };
              if (
                item.pricing.downloadUrl !== null &&
                item.pricing.downloadUrl !== undefined
              ) {
                pdfCell = {
                  text: `view`,
                  link: item.pricing.downloadUrl
                };
              } else if (item.pricing.pdfPath) {
                pdfCell = {
                  text: `view`,
                  link: item.pricing.pdfPath
                };
              }
              let finPriceCell = `$${finPrice.toLocaleString("en-US", {
                style: "currency",
                currency: "USD"
              })}`;
              let totDolarCell = `$${totDolar.toLocaleString("en-US", {
                style: "currency",
                currency: "USD"
              })}`;
              let refCell = `${item.ref ? item.ref : ""}`;
              let commentCell = `${item.comment ? item.comment : ""}`;

              tableBody.push([
                refCell,
                item.category.toUpperCase(),

                qty,

                item.title,

                // `$${finPrice.toLocaleString("en-US", {
                //   style: "currency",
                //   currency: "USD"
                // })}`,
                // `$${totDolar.toLocaleString("en-US", {
                //   style: "currency",
                //   currency: "USD"
                // })}`,
                finPriceCell,
                totDolarCell,

                {
                  text: `view`,
                  link: item.pricing.finalLink
                },
                pdfCell,

                item.userDescription,
                commentCell
              ]);
              // console.log("tableBody", tableBody);
            }
          }
        });
      }
      //==================================================
      let summaryBody = [
        [
          { text: "CATEGORY", alignment: "center" },
          { text: "TOTAL FOR CATEGORY", alignment: "center" }
        ]
      ];
      //==================================================
      let grandTotal = 0;

      for (const [key, value] of Object.entries(group)) {
        let total = 0;

        value.forEach(item => {
          let quantity = Number.parseInt(item.quantity);
          if (isNaN(quantity)) {
            console.log("isNaN quantity", item);
          }
          let finalPrice = Number.parseFloat(item.pricing.finalPrice).toFixed(
            2
          );
          if (isNaN(finalPrice)) {
            console.log("isNaN finalPrice", item);
          }
          let itemPrice = finalPrice * quantity;
          total = total + itemPrice;
        });
        let categoryTotal = Number.parseFloat(total).toFixed(2);
        grandTotal += total;
        summaryBody.push([
          { text: `${key.toUpperCase()}`, alignment: "center" },
          {
            text: `$${categoryTotal
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
            alignment: "center"
          }
        ]);
      }
      let almostFinalGrandTotal = Number.parseFloat(grandTotal).toFixed(2);
      let finalGrandTotal = new Intl.NumberFormat().format(
        almostFinalGrandTotal
      );
      summaryBody.push([
        { text: `GRAND TOTAL`, alignment: "center", bold: true },
        { text: `$${finalGrandTotal}`, alignment: "center", bold: true }
      ]);

      let refedItemCount = 0;
      let nonRefedItemCount = 0;
      let invoiceTotal = 0;
      this.pricedList.forEach(listItem => {
        // let quantity = Number.parseInt(listItem.quantity);

        if (listItem.ref !== null && listItem.ref !== undefined) {
          invoiceTotal = invoiceTotal + 1;
          refedItemCount = refedItemCount + 1;
        } else {
          invoiceTotal = invoiceTotal + 2;
          nonRefedItemCount = nonRefedItemCount + 1;
        }
      });
      let totalDue = Number.parseFloat(invoiceTotal).toFixed(2);
      this.totalDue = totalDue;

      //================================================================
      //create the pdf document

      let docDefinition = {
        // a string or { width: number, height: number }
        // images,
        defaultStyle: {
          // alignment: 'justify',
          font: "TimesRoman",
          fontSize: 12
        },
        pageSize: "LETTER",
        // by default we use portrait, you can change it to landscape if you wish
        pageOrientation: "landscape",
        // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
        pageMargins: [30, 30, 30, 30],
        // pageBreakBefore: function(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
        //   return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0;
        // },
        content: [
          {
            table: {
              // headerRows: 1,
              widths: ["*"],
              dontBreakRows: true,
              // keepWithHeaderRows: 1,
              body: [
                [
                  {
                    text: `${this.matter.lastName}, ${this.matter.firstName} - ${this.matter.caseName}`,
                    alignment: "center",
                    bold: true
                  }
                ],
                [
                  {
                    text: ` `
                  }
                ],
                [
                  {
                    text: `SUMMARY`,
                    alignment: "center",
                    bold: true
                  }
                ],
                [
                  {
                    text: ` `
                  }
                ]
              ]
            }
          },
          {
            table: {
              headerRows: 1,
              widths: ["*", "*"],
              body: summaryBody
            },
            pageBreak: "after"
          },

          {
            table: {
              headerRows: 1,
              widths: [30, 100, 25, 100, 50, 70, 50, 50, 100, "*"],
              dontBreakRows: true,
              // keepWithHeaderRows: 1,
              body: tableBody
              // body: finalTableBody
            }
          }
        ],
        footer: currentPage => {
          return [
            {
              table: {
                widths: ["*"],
                body: [
                  [
                    {
                      stack: [
                        {
                          text: `${currentPage.toString()}`,
                          alignment: "center",
                          fontSize: 9
                        },
                        {
                          text: `${this.matter.firmName} - ${this.matter.caseID}`,
                          alignment: "right",
                          fontSize: 8
                        }
                      ],
                      layout: { defaultBorder: false },
                      border: [false, false, false, false]
                    }
                  ]
                ]
              }
            }
          ];
        }
      };
      this.doc = pdfMake.createPdf(docDefinition);
      // this.doc.open();
      this.finalDocDialog = true;
      this.doc.getDataUrl(url => {
        this.iframeSrc = url;
      });

      //create invoice pdf

      this.priceOverlay = false;
      let invoiceNumber = Math.floor(Math.random() * 90000) + 10000;
      this.invoiceNumber = invoiceNumber;
      let amountDueCell = [];

      if (refedItemCount > 0 && nonRefedItemCount > 0) {
        amountDueCell.push(
          {
            text: `Contents List Pricing - \n ${refedItemCount} Items Auto-Priced ($1.00  per item) 
                  \n ${nonRefedItemCount} Items Manual-Priced ($2.00  per item)`,
            // text: `Contents List Pricing - \n ${this.contentsList.length} Items Priced ($1.00  per item)`,
            alignment: "center"
          },

          { text: `$${totalDue}`, alignment: "center" }
        );
      } else if (!refedItemCount > 0 && nonRefedItemCount > 0) {
        amountDueCell.push(
          {
            text: `Contents List Pricing - \n ${nonRefedItemCount} Items Manual-Priced ($2.00  per item)`,
            // text: `Contents List Pricing - \n ${this.contentsList.length} Items Priced ($1.00  per item)`,
            alignment: "center"
          },

          { text: `$${totalDue}`, alignment: "center" }
        );
      } else if (refedItemCount > 0 && !nonRefedItemCount > 0) {
        amountDueCell.push(
          {
            text: `Contents List Pricing - \n ${refedItemCount} Items Auto-Priced ($1.00  per item)`,
            // text: `Contents List Pricing - \n ${this.contentsList.length} Items Priced ($1.00  per item)`,
            alignment: "center"
          },

          { text: `$${totalDue}`, alignment: "center" }
        );
      }
      let docDefinitionInvoice = {
        defaultStyle: {
          // alignment: 'justify',
          font: "TimesRoman",
          fontSize: 12
        },
        pageSize: "LETTER",

        pageMargins: [30, 30, 30, 30],
        // pageBreakBefore: function(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
        //   return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0;
        // },
        content: [
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 5,
                x2: 595 - 2 * 40,
                y2: 5,
                lineWidth: 3
              }
            ]
          },

          { text: `TAPLAW INVOICE`, fontSize: 20 },
          { text: " " },
          { text: " " },
          { text: " " },
          { text: "TAPLAW INC.", fontSize: 12 },
          { text: "352 S Cloverdale Ave.", fontSize: 12 },
          { text: "Los Angeles, CA 90036", fontSize: 12 },
          { text: " " },
          { text: " " },
          { text: " " },
          { text: `TO: ` },
          { text: `${this.matter.firmName}` },
          { text: `${this.matter.firmAddressLine}` },
          { text: `${this.matter.firmCityStateZip}` },
          { text: `${this.matter.firmPhone}` },

          { text: " " },
          { text: " " },
          { text: " " },
          { text: "Please make checks payable to Taplaw Inc.", fontSize: 12 },
          { text: "Tax ID #: 87-4047075", fontSize: 12 },
          { text: " " },
          { text: " " },
          { text: " " },
          {
            text: `RE: ${this.matter.caseID} - ${this.matter.caseName} - ${this.matter.firstName} ${this.matter.lastName}`
          },
          {
            text: `Invoice No: ${invoiceNumber}`,
            fontSize: 20
          },
          { text: " " },
          { text: " " },
          { text: " " },
          { text: `DATE:  ${moment().format("LL")}` },
          { text: " " },
          { text: " " },
          { text: " " },
          { text: " " },
          { text: " " },
          { text: " " },
          {
            table: {
              headerRows: 1,
              dontBreakRows: true,
              widths: ["*", "*"],
              body: [
                [
                  { text: `ITEM`, alignment: "center" },
                  { text: `AMOUNT DUE`, alignment: "center" }
                ],

                amountDueCell
              ]
            }
          }
        ]
      };

      this.invoice = pdfMake.createPdf(docDefinitionInvoice);
      // this.invoice.download();
    },
    downloadDocs() {
      if (this.doc !== null && this.invoice !== null) {
        this.doc.download(`PRICING-${this.matter.propertySlug}.pdf`);
        this.invoice.download(
          `${this.totalDue}-no.${this.invoiceNumber}-${this.matter.caseID}-${this.matter.matterID}.pdf`
        );
      }
    },
    priceItem(item) {
      this.overlay2 = true;
      let searchTerm = `${item.title} ${
        item.userDescription ? item.userDescription : ""
      }`;
      let functionData = {
        searchTerm: searchTerm.trim(),
        category: item.category,
        ref: item.ref
      };
      console.log(functionData);
      const getPricing3 = firebase
        .app()
        .functions("us-west2")
        .httpsCallable("getPricing3", { timeout: 0 });
      getPricing3(functionData)
        .then(async resp => {
          let data = await resp.data;
          console.log("data,", data);
          // console.log("resp,", resp);
          firebase
            .firestore()
            .collection("fireMatters")
            .doc(this.$route.params.location)
            .collection("contentsList")
            .doc(item.title)
            .update({
              pricing: { ...data }
              // }).then(() => {
              //   let i = this.contentsList.findIndex(
              //     contentsListItem => contentsListItem.title === data.title
              //   );
              //   // let sortedListIndex = this.sortedList.findIndex(
              //   //   contentsListItem => contentsListItem.title === data.title
              //   // );
              //   this.contentsList[i].pricing = { ...data };
            })
            .catch(e => console.error(e.message));
          this.overlay2 = false;
          firebase
            .firestore()
            .collection("pricedItemList")
            .doc(data.searchTerm)
            .add({
              searchTerm: searchTerm,
              ref: item.ref,
              ...data
            });
          ``;
        })
        .catch(e => console.error(e.message));
    },
    async priceAll() {
      console.log(this.contentsList);
      //emulator
      // firebase
      //   .app()
      //   .functions("us-west2")
      //   .useFunctionsEmulator("http://localhost:5001");
      // console.log("not in emulator");
      // name function

      const getPricing3 = firebase
        .app()
        .functions("us-west2")
        .httpsCallable("getPricing3", { timeout: 0 });
      this.overlay2 = true;

      // let sanitizedSearchTerm = slugify(searchTerm, {
      //   replacement: "+",
      //   remove: /[$*_+~.()'"!\-:@,#]/g,
      //   lower: true
      // });

      // progress bar math
      //set progress bar interval
      let interval = 100 / this.contentsList.length;
      //keep track of item number
      let itemnumber = 0;
      this.contentsList.forEach(async item => {
        itemnumber++;
        //if progress bar is less than 100, add interval to progress bar
        if (this.progress < 100) {
          let tempProgress = this.progress + interval;
          console.log("temp progress", tempProgress);
          this.progress = tempProgress;
          console.log(this.progress);
        } else {
          //if progress bar is 100, reset progress bar
          this.progress = 0;
          this.overlay2 = false;
        }
        //set search term
        let searchTerm;
        if (item.title !== undefined && item.title !== null) {
          searchTerm = `${item.title} ${
            item.userDescription ? item.userDescription : ""
          }`;
        } else {
          console.log("item.title is undefined", item);
        }
        //set function data
        let functionData = {
          searchTerm: searchTerm.trim(),
          category: item.category,
          ref: item.ref
        };
        console.log("itemNumber", itemnumber);
        // console.log(functionData);
        //if itemnumber is less than 100, run function
        // if (itemnumber < 100) {
        // console.log("pricing this item", item.searchTerm);
        await getPricing3(functionData)
          .then(async resp => {
            let data = await resp.data;
            // console.log("data,", data);
            // console.log("resp,", resp);
            if (item.title !== undefined && item.title !== null) {
              console.log("adding item:", itemnumber);
              firebase
                .firestore()
                .collection("fireMatters")
                .doc(this.$route.params.location)
                .collection("contentsList")
                .doc(item.title)
                .update({
                  pricing: { ...data }
                  // }).then(() => {
                  //   let i = this.contentsList.findIndex(
                  //     contentsListItem => contentsListItem.title === data.title
                  //   );
                  //   // let sortedListIndex = this.sortedList.findIndex(
                  //   //   contentsListItem => contentsListItem.title === data.title
                  //   // );
                  //   this.contentsList[i].pricing = { ...data };
                })
                .catch(e => console.error(e.message));
            } else {
              console.log(`item.title is an issue for this item:`, item);
            }
            this.overlay2 = false;
            firebase
              .firestore()
              .collection("pricedItemList")
              .doc(data.searchTerm)
              .add({
                searchTerm: searchTerm,
                ref: item.ref,
                ...data
              });
          })
          .catch(e => console.error(e.message));
        // } else {
        //   //if itemnumber is 100, reset itemnumber and stop function
        //   console.log("itemnumber is 100, stopping function");
        //   this.overlay2 = false;
        // }
      });

      // let functionData = {
      //   searchTerm: searchTerm.trim(),
      //   category: this.contentsList[2].category,
      //   ref: this.contentsList[2].ref
      // };
      // console.log(functionData);

      // await getPricing3(functionData)
      //   .then(async resp => {
      //     let data = await resp.data;
      //     console.log("data,", data);
      //     console.log("resp,", resp);
      // this.overlay2 = false;
      //   })
      //   .catch(e => console.error(e.message));
    },
    viewPDF() {
      window.open(this.selectedItem.pricing.pdfPath, "_blank");
    },
    editCustomItem() {
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.$route.params.location)
        .collection("contentsList")
        //this is problematic because it uses title and not searcterms
        .doc(this.customItem.title)
        .set(this.customItem)
        .then(() => {
          // console.log("custom item edited");
          this.customItem = null;
          this.selectedItem = null;
          this.editCustomItemDialog = false;
          this.overlay = false;
        })
        .catch(e => console.error(e.message));
    },
    removeCustomItem() {
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.$route.params.location)
        .collection("contentsList")
        .doc(this.customItem.title)
        .delete()
        .then(() => {
          // console.log("custom item deleted");
          this.customItem = null;
          this.selectedItem = null;
          this.editCustomItemDialog = false;
          this.overlay = false;
        })
        .catch(e => console.error(e.message));
    },
    cancelEditCustomItem() {
      this.customItem = null;
      this.selectedItem = null;
      this.editCustomItemDialog = false;
      this.overlay = false;
    },
    flagItem(item) {
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.$route.params.location)
        .collection("reviewList")
        .doc(item.title)
        .set(item);
    },
    removeFlag(item) {
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.$route.params.location)
        .collection("reviewList")
        .doc(item.title)
        .delete();
    },
    selectItemFromContentsList(val) {
      // console.log("selectItemFromContentsList", val);
      // this.overlay = true;
      this.selectedItem = val;
      this.quantity = val.quantity;
      this.userDescription = val.userDescription;
      let index = this.items.findIndex(item => item.ref == val.ref);
      // console.log("found index", index);
      if (index !== -1) {
        this.selectedItemIndex = index;
      }
      this.selectedItemIndex = index;
      // this.overlay = false;
      this.quantity = val.quantity;
      this.userDescription = val.userDescription;
    },
    selectItemFromPricedList(val) {
      this.selectedItem = val;
      this.quantity = val.quantity;
      this.userDescription = val.userDescription;
      let index = this.items.findIndex(item => item.ref == val.ref);
      // console.log("found index", index);
      if (index !== -1) {
        this.selectedItemIndex = index;
      }
      this.selectedItemIndex = index;
      // this.overlay = false;
      this.quantity = val.quantity;
      this.userDescription = val.userDescription;
      if (this.role == "admin") {
        this.pricing = val.pricing;
      }
    },
    selectItem(i) {
      this.selectedItem = this.items[i];
      // this.selectedItemIndex = i;
      // console.log("index", this.selectedItemIndex);
    },
    previousItem() {
      let i = this.selectedItemIndex - 1;
      this.selectedItem = this.items[i];
      this.selectedItemIndex = i;
      // console.log("selectedItemIndex", this.selectedItemIndex);
    },
    nextItem() {
      let i = this.selectedItemIndex + 1;
      this.selectedItem = this.items[i];
      this.selectedItemIndex = i;
    },
    addNewItem() {
      let newItem = {
        // category: this.newItemCategory,
        category: this.category,
        quantity: this.newItemQuantity,
        userDescription: this.newItemDescription,
        title: this.newItemName
      };
      // let terms = newItem.title + " " + newItem.userDescription;
      // // console.log("terms", terms);
      // let searchTerms = slugify(terms, {
      //   replacement: "+",
      //   remove: /[$*_+~.()'"!\-:@,#]/g,
      //   lower: true
      // });
      // newItem.searchTerms = searchTerms;

      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.$route.params.location)
        .collection("contentsList")
        .doc(newItem.title)
        .set(newItem)
        .then(() => {
          this.newItemCategory = null;
          this.newItemQuantity = 0;
          this.newItemDescription = null;
          this.newItemName = null;
          this.cancelNewItemDialog();
        });
    },
    cancelNewItemDialog() {
      this.addItemDialog = false;
    },
    saveReviewItems() {
      this.toReviewList.forEach(item => {
        firebase
          .firestore()
          .collection("fireMatters")
          .doc(this.$route.params.location)
          .collection("reviewList")
          .doc(item.title)
          .set(item);
      });
      this.existingItemIndex = [];
    },
    removeReviewItem(item) {
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.$route.params.location)
        .collection("reviewList")
        .doc(item.title)
        .delete();
    },
    deSelect() {
      this.select = null;
      this.selectDialog = false;
      this.items = [];
    },
    goToCat() {
      // console.log(this.select);
      this.category = this.select;
      this.select = null;
      this.selectDialog = false;
    },
    async clearCat() {
      this.select = await null;
      this.category = await null;
      this.selectedItem = await null;
      this.items = await [];

      this.selectDialog = await false;
      this.quantity = await 0;
      this.userDescription = await null;
      this.itemObject = await null;
      this.storeSelection = await null;
    },
    addItem() {
      this.selectedItem;
      this.userDescription = `${
        this.userDescription ? this.userDescription : ""
      } ${this.storeSelection ? this.storeSelection : ""}`;

      let finalItem = {
        ...this.itemObject
      };
      finalItem.quantity = this.quantity;
      finalItem.userDescription = this.userDescription.trim();
      // let terms = finalItem.title + " " + finalItem.userDescription;
      // // console.log("terms", terms);
      // let searchTerms = slugify(terms, {
      //   replacement: "+",
      //   remove: /[$*_+~.()'"!\-:@,#]/g,
      //   lower: true
      // });

      // // console.log("this is location", this.$route.params.location);
      // finalItem.searchTerms = searchTerms;

      // console.log("finalitem", finalItem);
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.$route.params.location)
        .collection("contentsList")
        .doc(finalItem.title)
        .set(finalItem)
        .then(() => {
          // console.log("resp from .set", response);
          this.withinContentsList = true;
          let q = this.contentsList.find(
            contentsListItem => contentsListItem.title === finalItem.title
          );
          if (q !== null && q !== undefined) {
            this.withinContentsList = true;
            let i = this.items.findIndex(
              contentsListItem => contentsListItem.title === q.title
            );
            let p = this.contentsList.findIndex(
              contentsListItem => contentsListItem.title === q.title
            );
            // console.log(i);
            this.items[i].withinContentsList = true;
            this.contentsList[p].quantity = finalItem.quantity;
            this.contentsList[p].userDescription = finalItem.userDescription;
          }
          // finalItem = null;
        })
        // .then(() => {
        //   finalItem = null;
        // })
        .catch(e => {
          console.log(e.message);
          finalItem = null;
          this.storeSelection = null;
        });
    },
    removeItem() {
      console.log("remove item", this.selectedItem);

      let itemID = "";
      this.selectedItem.pricing && this.selectedItem.pricing.searchTerms
        ? (itemID = this.selectedItem.pricing.searchTerms)
        : (itemID = this.selectedItem.title);
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.$route.params.location)
        .collection("contentsList")
        .doc(itemID)
        .delete()
        .then(() => {
          // console.log("item deleted");
          this.withinContentsList = false;
          this.quantity = 0;
          this.pricing = null;
          this.selectedItem.withinContentsList = false;
        })
        .catch(e => {
          console.error(e.mesage);
        });
    }
  },
  created() {
    // console.log("router", this.$route.params);
    //GET CATEGORIES FUNCTION IS DECLARED
    //THIS IS A CLOUD FUNCTION IN firebase/funcitons
    const getCategories = firebase
      .functions()
      .httpsCallable("getCategories", { timeout: 0 });
    // console.log("hello from contents stepper 3");
    //GET CATEGORIES IS CALLED
    getCategories()
      .then(resp => {
        //THE RESPONSE IS AN ARRAY
        //WHICH IS LOOPED OVER AND EACH IS ADDED TO THIS.MENU
        resp.data.forEach(menuItem => {
          this.menu.push(menuItem);
        });
      })
      .catch(err => {
        console.log(err.message);
      });

    // THE MATTER IS GRABBED FROM DB
    // USING THE USRL ROUTER PARAM "location"
    // "location" is the (slugged) street address of the property
    // associated with this matter
    // THIS MATTER OBJECT WAS ALREADY
    // CREATED BY THE ADMIN USER FIRM SIDE
    // THE MATTER IS SET TO this.matter
    // the onSnapshot function will fire when the matter changes in DB
    firebase
      .firestore()
      .collection("fireMatters")
      .doc(this.$route.params.location)
      .onSnapshot(res => {
        this.matter = res.data();
        // console.log("this.matter from created", this.matter);
      });
    // SEPPARETELY THIS FUNCTION IS ACCESSING
    // THE 'contentsList' COLLECTION IN DB
    // WITHIN THE MATTER
    // (contnetsList is a collection within a collection
    // and requires this additional request as far as I know)
    // THIS IS ALSO A onSnapshot LISTENING REQUEST (SEE ABOVE)
    firebase
      .firestore()
      .collection("fireMatters")
      .doc(this.$route.params.location)
      .collection("contentsList")
      // .onSnapshot(res => {
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.type === "added") {
            // console.log("New item: ", change.doc.data());
            let data = change.doc.data();
            if (this.role === "admin") {
              if (data.pricing && data.pricing.finalPrice) {
                this.pricedList.push({ ...data });
                if (isNaN(data.pricing.finalPrice)) {
                  console.log("data.pricing.finalPrice isNaN", data);
                }
              } else {
                this.contentsList.push({
                  title: `${
                    data.title ? data.title.replace(/^a-zA-Z0-9 ]/g, "") : ""
                  }`,
                  ref: data.ref,
                  quantity: data.quantity,
                  userDescription: `${
                    data.userDescription
                      ? data.userDescription.replace(/^a-zA-Z0-9 ]/g, "")
                      : ""
                  }`,
                  category: `${
                    data.category
                      ? data.category.replace(/^a-zA-Z0-9 ]/g, "")
                      : ""
                  }`,
                  pricing: {}
                });
              }
            } else {
              this.contentsList.push({
                title: `${
                  data.title ? data.title.replace(/^a-zA-Z0-9 ]/g, "") : ""
                }`,
                ref: data.ref,
                quantity: data.quantity,
                userDescription: `${
                  data.userDescription
                    ? data.userDescription.replace(/^a-zA-Z0-9 ]/g, "")
                    : ""
                }`,
                category: `${
                  data.category
                    ? data.category.replace(/^a-zA-Z0-9 ]/g, "")
                    : ""
                }`,
                pricing: null
              });
            }
          }
          if (change.type === "modified") {
            // console.log("Modified item", change.doc.data());
            let index = this.contentsList.findIndex(
              contentsListItem =>
                contentsListItem.title === change.doc.data().title
            );
            let data = change.doc.data();
            if (this.role === "admin") {
              if (data.pricing && data.pricing.finalPrice) {
                // let i = this.pricedList.findIndex(
                //   contentsListItem =>
                //     contentsListItem.title === change.doc.data().title
                // );
                // console.log("got pricedList item index for modified item changing the item now", i);
                // this.pricedList[i] = {
                //   ...data
                // };
                // console.log("pricedList", this.pricedList[i])
                let index = this.contentsList.findIndex(
                  contentsListItem =>
                    contentsListItem.title === change.doc.data().title
                );
                this.$set(this.contentsList[index], "pricing", {
                  ...data.pricing
                });
                // console.log(
                //   "got contentsList item index for modified item",
                //   index
                // );
                // console.log("this.contentsList", this.contentsList);
                // console.log("pricedList", this.pricedList);
                let replacementItem = {
                  ...data
                };
                this.contentsList.splice(index, 1, replacementItem);
                // this.contentsList[index] = {
                //   ...data
                // };
                // this.$set(this.contentsList[index], "pricing", {
                //   ...data
                // });
                // console.log(
                //   "this.contentsList after change",
                //   this.contentsList
                // );
              } else {
                let i = this.contentsList.findIndex(
                  contentsListItem => contentsListItem.title === data.title
                );
                // console.log("got contentsList item index for modified item", i);
                // console.log("this.contentsList[i]", this.contentsList[i]);
                // console.log("data", data);
                let replacementItem = {
                  title: `${
                    data.title ? data.title.replace(/^a-zA-Z0-9 ]/g, "") : ""
                  }`,
                  ref: `${data.ref ? data.ref : null}`,
                  quantity: data.quantity,
                  userDescription: `${
                    data.userDescription
                      ? data.userDescription.replace(/^a-zA-Z0-9 ]/g, "")
                      : ""
                  }`,
                  category: `${
                    data.category
                      ? data.category.replace(/^a-zA-Z0-9 ]/g, "")
                      : ""
                  }`,
                  pricing: null
                };
                this.contentsList.splice(i, 1, replacementItem);
                // this.contentsList[i] = {
                //   title: `${data.title ? data.title.replace(/^a-zA-Z0-9 ]/g, "") : ""
                //     }`,
                //   ref: `${data.ref ? data.ref : null}`,
                //   quantity: data.quantity,
                //   userDescription: `${data.userDescription
                //     ? data.userDescription.replace(/^a-zA-Z0-9 ]/g, "")
                //     : ""
                //     }`,
                //   category: `${data.category
                //     ? data.category.replace(/^a-zA-Z0-9 ]/g, "")
                //     : ""
                //     }`,
                //   pricing: null
                // };
                // console.log(
                //   "this.contentsList[i] after change",
                //   this.contentsList[i]
                // );
              }
            } else {
              let replacementItem = {
                title: `${
                  data.title ? data.title.replace(/^a-zA-Z0-9 ]/g, "") : ""
                }`,
                ref: `${data.ref ? data.ref : null}`,
                quantity: data.quantity,
                userDescription: `${
                  data.userDescription
                    ? data.userDescription.replace(/^a-zA-Z0-9 ]/g, "")
                    : ""
                }`,
                category: `${
                  data.category
                    ? data.category.replace(/^a-zA-Z0-9 ]/g, "")
                    : ""
                }`,
                pricing: null
              };
              this.contentsList.splice(index, 1, replacementItem);
              // this.contentsList[index] = {
              //   title: `${data.title ? data.title.replace(/^a-zA-Z0-9 ]/g, "") : ""
              //     }`,
              //   ref: `${data.ref ? data.ref : null}`,
              //   quantity: data.quantity,
              //   userDescription: `${data.userDescription
              //     ? data.userDescription.replace(/^a-zA-Z0-9 ]/g, "")
              //     : ""
              //     }`,
              //   category: `${data.category
              //     ? data.category.replace(/^a-zA-Z0-9 ]/g, "")
              //     : ""
              //     }`,
              //   pricing: null
              // };
            }
          }
          if (change.type === "removed") {
            console.log("Removed item: ", change.doc.data());
            let index = this.contentsList.findIndex(
              contentsListItem =>
                contentsListItem.title === change.doc.data().title
            );
            this.contentsList.splice(index, 1);
            let i = this.pricedList.findIndex(
              contentsListItem =>
                contentsListItem.title === change.doc.data().title
            );
            this.pricedList.splice(i, 1);
          }
        });

        //   //================================================================================================
        //   // THIS SHOULD PROBABLY NOT EMPTY
        //   // THE EXISTING this.contentsList
        //   // EVERY TIME A  CHANGE OCCURS IN BD
        //   this.contentsList = [];
        //   //DO SOMETHING FOR EACH ITEM
        //   res.forEach(item => {
        //     //this item could have a bunch of information on it
        //     // however we only want this CLIENT FACING route
        //     // to show the existing list and allow the user to delete
        //     // or edit each item / or to flag the item to be reviewed (maybe)

        //     let data = item.data();
        //     if (data.category == null || data.category == undefined) {
        //       // console.log(data);
        //       //place item in to review list
        //     }
        //     let pricing = null;
        //     if (data.pricing !== null && data.pricing !== undefined) {
        //       pricing = data.pricing;
        //       // console.log("pricing", pricing);
        //     }
        //     //IF THIS IS A FIRM USER
        //     // console.log("role", this.role);
        //     if (this.role === "admin") {
        //       //ADD PRICING TO THE ITEM AND PUSH INTO CONTENTSLIST
        //       this.contentsList.push({
        //         title: data.title,
        //         ref: data.ref,
        //         quantity: data.quantity,
        //         userDescription: data.userDescription,
        //         category: data.category,
        //         pricing: pricing
        //       });
        //       if (data.pricing !== null && data.pricing !== undefined) {
        //         if (
        //           data.pricing.finalPrice !== null &&
        //           data.pricing.finalPrice !== undefined
        //         ) {
        //           this.pricedList.push({ ...data });
        //         }

        //         console.log("pricedList", this.pricedList);
        //       }
        //     } else {
        //       //IF THISE IS A CLIENT FACING USER (NO ADMIN IN THE URL)
        //       this.contentsList.push({
        //         //DONT PUT PRICING IN THE OBJECT (TRYING TO SAVE MEMORY BUT NOT QUITE WORKING)
        //         title: data.title,
        //         ref: data.ref,
        //         quantity: data.quantity,
        //         userDescription: data.userDescription,
        //         category: data.category,
        //         pricing: null
        //       });
        //     }
        //   });

        //   res = null;
      });

    //GRAB THE ITEMS THAT HAVE BEEN FLAGGED
    //ANOTHER SNAPSHOT
    firebase
      .firestore()
      .collection("fireMatters")
      .doc(this.$route.params.location)
      .collection("reviewList")
      .onSnapshot(res => {
        // console.log("conentsList snapshot fireing", res);
        // let data = res.data();
        this.savedReviewList = [];
        res.forEach(item => {
          let data = item.data();
          // console.log("saved review list from snapshot", data);
          this.savedReviewList.push({
            title: data.title,
            ref: data.ref,
            quantity: data.quantity,
            userDescription: data.userDescription,
            category: data.category
          });
        });
      });
  }
};
</script>

<style></style>
